module.exports = __webpack_public_path__ + "media/icon_transaction/rabit_5-6e1a80a2.png";